import React from 'react';
import Proptypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import { Line } from 'rc-progress';
import { Notice } from 'sarsaparilla';
import { getSaveStatus } from "../../reducers/saveStatus";

import styles from './SaveStatus.scss';

const propTypes = {
  status: Proptypes.shape({
    total: Proptypes.number,
    complete: Proptypes.number,
    errors: Proptypes.arrayOf(Proptypes.shape({
      description: Proptypes.string
    }))
  })
};

export function SaveStatus(props) {
  const { total, complete } = props.status;
  return(
    <div className={styles["save-errors"]}>
      <Notice noticeType="error" showClose={false} showNotice={props.status.errors.length > 0}>
        <div className="rec-notification-title">Problems while saving:</div>
        <ul>
          {props.status.errors.map((error, i) => (
            <li key={`${error.description}-${i}`}>Problem {error.description}</li>
          ))}
        </ul>
      </Notice>
      <Modal
        isOpen={total > 0}
        onRequestClose={() => {}}
        ariaHideApp={false}
        className={{
          base: `${styles.modal} rec-modal-dialog-base`,
          afterOpen: 'rec-modal-dialog-after-open-md',
          beforeClose: 'rec-modal-dialog-before-close'
        }}
        overlayClassName={{
          base: 'rec-overlay-base',
          afterOpen: 'rec-overlay-after-open',
          beforeClose: 'rec-overlay-before-close'
        }}
        contentLabel="Saving progress">
        <div className={styles["modal-wrapper"]}>
          <h2>Synching Changes</h2>
          <p>Please wait</p>
          <Line
            percent={100.0 * complete/total}
            trailWidth="3"
            strokeWidth="3" />
          <p><strong>Do not reload or refresh Browser</strong></p>
        </div>
      </Modal>
    </div>
  );
}

SaveStatus.propTypes = propTypes;

function mapStateToProps(state) {
  return{
    status: getSaveStatus(state)
  };
}

export default connect(mapStateToProps)(SaveStatus);
